module.exports = __webpack_public_path__ + "static/media/about1.f161b38f.png";